<template>
  <div
    id="contact"
    ref="itemWrapper"
    tabindex="0"
    class="contact page"
    @keyup.esc="returnHome"
  >
    <router-link to="/">
      <img
        class="close-view"
        src="@/assets/close.svg"
        alt=""
      >
    </router-link>
    <h1 class="contact__title">Contact</h1>
    <div class="contact__content">
      <div class="contact__content--left">
        <img
        class="contact__img"
        alt=""
        :src="`https://res.cloudinary.com/bparticle/image/upload/w_550/v1549027560/brunopatyn/caylus_studio.jpg`"
        >
      </div>
      <div class="contact__content--right">
        <p class="contact__paragraph">
          <a href="mailto:b.bpatyn@gmail.com">>> email me</a> <br>
          <a target="_blank" href="https://instagram.com/brunopatyn">Instagram account</a> <br>
          You can also call me ++32 484/97.33.68
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../router"

export default {
  name: 'Contact',
  data() {
    return {}
  },
  mounted() {
    this.$refs.itemWrapper.focus()
  },
  methods: {
    returnHome: function () {
      router.push('/')
    }
  }
}
</script>

<style lang="scss">
  .contact {

    &__title {
      margin-top: 0;
      padding-top: 65px;
      padding-left: 15px;
      color: gray;
    }

    &__paragraph {
      margin-top: 0;
      color: gray;
    }

    &__content {
      max-width: 1100px;
      margin: 0 auto;
      padding: 50px 0;
      overflow: hidden;
      &--left {
        width: 50%;
        float: left;
      }
      &--right {
        width: 50%;
        float: right;
        padding-left: 15px;
      }
    }
  }

  @media all and (max-width: 1130px) {

    .contact {
      padding: 0 15px;

      &__title {
        padding-left: 0;
      }
    }

  }
</style>
